/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";

import { CheckIcon, RowCell, StyledTable } from "./Styled";

interface ProgressiveStep {
    from: number;
    coefficient: number;
}

interface ProgressiveScaleProps {
    currentPercent: number;
    progressive: ProgressiveStep[];
}

interface DataRecord {
    key: number;
    percent: string;
    coefficient: string;
    completed: boolean;
}

const columns = [
    {
        title: "Відсоток виконання плану",
        dataIndex: "percent",
        key: "percent",
        children: [
            {
                dataIndex: "completed",
                key: "completed",
                width: 68,
                render: (_: any, record: DataRecord) => (
                    <RowCell>
                        <CheckIcon $active={record.completed} />
                    </RowCell>
                ),
            },
            {
                dataIndex: "percent",
                key: "percent-text",
                render: (_: any, record: DataRecord) => (
                    <RowCell>{record.percent}</RowCell>
                ),
            },
        ],
        render: (_: any, record: DataRecord) => (
            <RowCell>
                <CheckIcon $active={record.completed} />
                {record.percent}
            </RowCell>
        ),
    },
    {
        title: "Коефіцієнт",
        dataIndex: "coefficient",
        key: "coefficient",
        render: (_: any, record: DataRecord) => (
            <RowCell>{record.coefficient}</RowCell>
        ),
    },
];

export const ProgressiveScale: FC<ProgressiveScaleProps> = ({
    currentPercent,
    progressive,
}) => {
    const data: DataRecord[] = progressive.map((item, index) => ({
        key: index,
        percent: `${item.from}%`,
        coefficient: item.coefficient.toString(),
        completed: item.from <= currentPercent,
    }));

    return (
        <FlexContainer
            width="100%"
            gap="24px"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="flex-start"
        >
            <PrimaryText
                fontSize={14}
                fontWeight="400"
                lineHeight="140%"
                padding="0 20px"
            >
                Прогресивна шкала — це система нарахування бонусів, в якій
                коефіцієнт зростання збільшується при досягненні наступного
                кроку відсотку виконання плану.
            </PrimaryText>

            <StyledTable
                columns={columns}
                bordered
                dataSource={data}
                pagination={false}
                rowKey="key"
            />
        </FlexContainer>
    );
};
